import { enGbLocale } from '@manigo/manigo-commons';

import {
    BASE_API_URL, SUPPORTED_LANGUAGES, TIME_TO_AUTO_LOGOUT_COUNTDOWN, KYC_KYB_MODE, ENABLE_TEXT_LOADER_ON_LOGIN, COUNTRY_DROPDOWN_PINNED_ITEMS,
} from './environment';


export const baseApiUrl = BASE_API_URL;

export const localesManifestFileName = 'locales-manifest.json';
export const sessionUuidKey = 'sessionUuid';
export const permissionsKey = 'permissions';
export const companyDetailsKey = 'companyDetails';
export const primaryColorSchemeKey = 'BWP_colorSchemeKey';
export const secondaryColorSchemeKey = 'BWP_secondaryColorSchemeKey';
export const clientConfigKey = 'clientConfig';
export const localesManifestKey = 'localesManifest';
export const userPreferencesKey = 'preferences';
export const appHistoryTrace = 'appHistoryTrace';
export const rememberMeLoginForm = 'rememberMe';
export const selectedLanguageStorageKay = 'BWP_selectedLanguage';
export const timeToAutoLogoutCountDownBanner = (Number(TIME_TO_AUTO_LOGOUT_COUNTDOWN) || 4) * 60 * 1000; // in milliseconds


export const standardPaginationOptions = [5, 10, 20, 50];

export const standardPageSize = 6;


export const defaultLocale = SUPPORTED_LANGUAGES.find((locale) => locale.default)?.key || enGbLocale;
export const SUM_SUB_IFRAME_ID = 'sumsub-iframe';
export const kycKybMode = KYC_KYB_MODE;
export const enableTextLoaderOnLogin = ENABLE_TEXT_LOADER_ON_LOGIN;
export const countryDropdownPinnedItems = COUNTRY_DROPDOWN_PINNED_ITEMS;
